import { Component, OnInit } from '@angular/core';
import { BreadcrumbComponent } from "../../../shared/components";

@Component({
  selector: 'app-listado-ac',
  templateUrl: './listado-ac.component.html',
  styleUrls: ['./listado-ac.component.css'],
  standalone: true,
  imports: [
    BreadcrumbComponent
  ]
})
export class ListadoAcComponent implements OnInit {
  breadcrumbs: any = {
    title: 'Reporte de Asistencia',
    breadcrumbs: [
      { label: 'HOME', link: '/home' },
      { label: 'Reporte de Asistencia', link: '' }
    ]
  };

  constructor() { }

  ngOnInit() {
  }

}
